import { render } from "./ToastNotifyListComp.vue?vue&type=template&id=5bd9e831&scoped=true"
import script from "./ToastNotifyListComp.vue?vue&type=script&lang=js"
export * from "./ToastNotifyListComp.vue?vue&type=script&lang=js"

import "./ToastNotifyListComp.vue?vue&type=style&index=0&id=5bd9e831&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd9e831"]])

export default __exports__